import React from 'react';
import VisibleInDevelopment from '../development/visible-in-development';

interface Props {
  name: string;
}

export default function TodoFeature({ name }: Props) {
  return (
    <VisibleInDevelopment>
      <h3>Feature to do: {name}</h3>
    </VisibleInDevelopment>
  );
}
